import React from 'react';
import { Button } from './ui/Button';
import { useTags } from '../hooks/useTags';

interface TagSelectProps {
  selectedTag: string;
  onTagSelect: (tag: string) => void;
  onAddTag: () => void;
  disabled?: boolean;
}

export function TagSelect({ selectedTag, onTagSelect, onAddTag, disabled }: TagSelectProps) {
  const { tags, loading } = useTags();

  return (
    <div className="flex gap-2">
      <select
        value={selectedTag}
        onChange={(e) => onTagSelect(e.target.value)}
        className="flex-1 p-2 border rounded-lg"
        disabled={loading || disabled}
      >
        <option value="">Select a tag...</option>
        {tags.map((tag) => (
          <option key={tag.id} value={tag.value}>
            {tag.value}
          </option>
        ))}
      </select>
      <Button
        onClick={onAddTag}
        type="button"
        disabled={!selectedTag || disabled}
      >
        Add
      </Button>
    </div>
  );
}